import React, { useEffect } from "react";
import { Box, Button } from "@mui/material";
// import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
// import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
// import CustomInput from "../../components/inputField";
import Logo from "../../../assets/images/loginLogo.svg";
import topBorder from "../../../assets/images/topBorder.png";
import "./login.css";
import loginService from "../../../services/loginServices";

const LoginForm: React.FC = () => {
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  // const [showPassword, setShowPassword] = useState(false);

  // Handle login submission
  useEffect(() => {
    loginWithOktaOnLoad();
  }, []);

  const loginWithOktaOnLoad = async () => {
    try {
      window.location.href = loginService.loginWithOtkaAuthentication();
    } catch (error) {
      console.error("Login Error:", error);
    }
  };
  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    loginWithOktaOnLoad();
  };

  return (
    <Box className="login-container" pt={0}>
      <Box className="login-box">
        <img src={topBorder} width={"100%"} alt="Royal Enfield" />
        <Box className="login-form">
          <Box className="login-logo">
            <img src={Logo} alt="Logo" height={"40px"} />
          </Box>

          {/* <Typography
            variant="h5"
            fontWeight="bold"
            my={2}
            sx={{ fontFamily: "Georgia, serif", fontSize: "24px" }}
          >
            Login
          </Typography> */}

          {/* Form Submission */}
          {/* <form onSubmit={handleLogin}>
            <Box mb={1}>
              <CustomInput
                label="Email address"
                type="email"
                name="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                backgroundColor="#ffffff"
              />
            </Box>

            <Box mb={1}>
              <CustomInput
                label="Password"
                type={showPassword ? "text" : "password"}
                backgroundColor="#ffffff"
                name="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                endAdornment={
                  <IconButton
                    onClick={() => setShowPassword((prev) => !prev)}
                    edge="end"
                  >
                    {showPassword ? (
                      <VisibilityOutlinedIcon />
                    ) : (
                      <VisibilityOffOutlinedIcon />
                    )}
                  </IconButton>
                }
              />
            </Box>

          </form> */}
          <Box className="loginBtn_sec">
            <Button
              fullWidth
              variant="contained"
              className="main__btn"
              type="submit"
              sx={{
                background: "#e2231a",
                borderRadius: "0px",
                marginTop: "10px",
                marginBottom: "10px",
              }}
              onClick={handleLogin}
            >
              Login With Okta
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LoginForm;
